import {useState} from 'react'
import {useParams} from 'react-router-dom'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import useConfrimCookie from 'shared/model/useConfrimCookie'
import useLoginCookie from 'shared/model/useLoginCookie'
import DefaultButton from 'shared/ui/DefaultButton'
import Style from '../../style'

const QualificationSelect = ({data}) => {
	const [, setConfrimEvent] = useConfirmModalAtom()

	// Ensure we have a valid initial value, default to 1 if missing
	const initialValue = data?.pro_grade_flag || 1
	const [selectedValue, setSelectedValue] = useState(initialValue)

	const {idx} = useParams()
	const [, setAlert] = useAlertModalAtom()

	const [confirmCookie] = useConfrimCookie()
	const [cookie] = useLoginCookie()

	const utcDate = new Date(data?.qualification_date)
	utcDate.setHours(utcDate.getHours())
	const mapperDate = utcDate.toLocaleString()

	const handleSelectChange = (event) => {
		setSelectedValue(Number(event.target.value))
	}

	const submitLevel = async () => {
		const response = await fetch(
			`${process.env.REACT_APP_BACKEND_URL}/admin/account/${idx}/grade`,
			{
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
					token: cookie,
					confirm: confirmCookie,
				},
				body: JSON.stringify({
					new_grade_flag: selectedValue,
					manager_idx: data?.manager_idx,
				}),
			}
		)

		switch (response.status) {
			case 200:
				window.location.reload()
				break
			case 400:
				setAlert('현재 등급과 동일합니다.')
				break
			default:
				alert('서버에러가 발생 했습니다.')
		}
	}

	return (
		<Style.QualAreaDiv>
			<h2 onClick={() => console.log(selectedValue)}>프로 자격</h2>
			<div className='_selectArea'>
				<Style.TableDiv>
					<Style.TableElement>
						<h2>{'자격요건'}</h2>
						<select
							className='_select'
							value={selectedValue}
							onChange={handleSelectChange}
						>
							{data?.qualification_lists?.map((elem, i) => (
								<option key={i} value={elem?.idx}>
									{data?.manager_name} - {elem?.qualification_name}
								</option>
							))}
						</select>
					</Style.TableElement>
				</Style.TableDiv>
				<DefaultButton
					fitWidth
					small
					clickEvent={() =>
						setConfrimEvent(
							'사용자 자격을 변경하시겠습니까?',
							() => submitLevel
						)
					}
				>
					변경
				</DefaultButton>
			</div>

			<Style.TableDiv>
				<Style.TableElement>
					<h2>{'자격시작일'}</h2>
					<p>{mapperDate}</p>
				</Style.TableElement>
			</Style.TableDiv>
		</Style.QualAreaDiv>
	)
}

export default QualificationSelect
